<template>
    <div class="iframe-tool"
        :style="{ width: width + 'px', height: height + 'px', top: top + 'px', left: left + 'px' }">
        <iframe ref="iframeContent" :src="iframeSrc" frameborder="0" :width="width" :height="height" :style="getTransform"></iframe>
        <slot></slot>

    </div>
</template>

<script>
import dragElem from '../DragElem.vue';
export default {
    name: "IframeWindow",
    data: function () {
        return {
        }
    },
    methods: {
    },
    mixins: [
        dragElem
    ],
    props: {
        iframeSrc: String,
        width: Number,
        height: Number
    },
    computed: {
        getTransform() {
            return {
                transform: `scale(${window.devicePixelRatio})`
            }
        }
    }
}
</script>

<style scoped>
.iframe-tool {
    position: absolute;
    z-index: var(--z-index-iframe-tool);
}

.move {
    position: absolute;
    width: 800px;
    height: 600px;
    top: 0px;
    left: 0px;
    pointer-events: none;
    /* cursor: move; */
}

.moveable {
    pointer-events: fill;
    cursor: move;
}
</style>